async function browserIsSafari() {
    return /.*Version.*Safari.*/.test(navigator.userAgent);
}
export default browserIsSafari;
//# sourceMappingURL=is-safari.js.map